




import { Component, Mixins } from "vue-property-decorator";
import BaseServiceMixin from "../mixins/base.service.mixin";
import IntegrationService from "../services/integration.service";
import Shared from "../common/shared";
import eventBus from "../common/bus";

@Component
export default class Home extends Mixins(BaseServiceMixin) {
  private integrationService!: IntegrationService;

  public async created() {
    this.integrationService = new IntegrationService(this.axiosInstance);
  }

  private async mounted() {
    const params = this.$route.query;
    if (!("code" in params)) {
      return;
    }

    const code = params.code as string;
    Shared.showToastMessage("Please wait while we verify your integration", "is-info");
    eventBus.$emit("loading", true);
    try {
      const integrationId: string | null = localStorage.getItem(Shared.localStorageKeys.INTEGRATION_ID);
      if (integrationId) {
        const integrationKey = await this.integrationService.activateIntegration(integrationId, code);
        this.vuexStore.setCompanyAPIKey(integrationKey);
        Shared.showToastMessage("Integration verification successful", "is-success");
        localStorage.removeItem(Shared.localStorageKeys.INTEGRATION_ID);
        eventBus.$emit("refresh-company");
        this.$router.push({ name: "Integrations" });
      }
    } catch (error) {
      // Handle Error
    } finally {
      eventBus.$emit("loading", false);
    }
  }
}
